import HeatGoogleMap from "./HeatGoogleMap";

export default HeatGoogleMap;